import React from 'react';
import { useHistory } from 'react-router-dom';
import GuestLayout from '../../../components/external/guest-layout';
import css from './index.module.css';
import { DASHBOARD } from '../../../router/routes';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { useMessageModal } from '../../../hooks/use-message-modal';
import { route } from '../../../services/utils';

export default function Homepage() {
  const history = useHistory();

  const { selectedFarm, maintenanceMode } = useSelector((state: RootState) => ({
    maintenanceMode: state.global?.maintenanceMode,
    selectedFarm: state.global.farm,
  }));

  if (selectedFarm) {
    history.push(route(DASHBOARD, { farmId: selectedFarm.id }));
  }

  const messageModal = useMessageModal();

  return (
    <GuestLayout showFoter>
      <div className={css['wrapper']}>
        <div className={css['wrapper-bg']} />
        <div className="container mx-auto px-4 relative">
          <div className={css['content']}>
            {maintenanceMode ? (
              <>
                <h2>{maintenanceMode.title}</h2>
                <h3>{maintenanceMode.content}</h3>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      {messageModal}
    </GuestLayout>
  );
}
